export const MuiMenu = () => {
    return {
        styleOverrides: {
            paper: {
                minWidth: '160px'
            }
        }
    };
};
